import type { Doc } from "building-types/doc";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import {
  getDocEntityIdFromGeneratedRoomLayoutEligibleEntity,
  isRoomLayoutEligibleEntity,
} from "../rooms/layout/roomLayoutTools";
import { docEntityHandleIsTableBased } from "./docEntityHandleIsTableBased";
import docGetEntity from "./docGetEntity";

export function docGetEntityId(doc: Doc, handle: DocEntityHandle): string | undefined {
  const entity = docGetEntity(doc, handle) as DocEntityBase;

  if (!entity) {
    return undefined;
  }

  if (isRoomLayoutEligibleEntity(entity)) {
    return getDocEntityIdFromGeneratedRoomLayoutEligibleEntity(entity);
  }

  if (docEntityHandleIsTableBased(handle)) {
    return entity.id;
  }

  switch (handle.type) {
    case "ROOF_SIDE": {
      return handle.side;
    }
    case "OPTION": {
      return handle.optionKey;
    }
    case "CATALOG_ITEM": {
      return handle.itemId;
    }
    case "SHAPE": {
      return handle.shapeId;
    }
    case "FLOOR_PERIMETER_OPENING": {
      return `${handle.floorId}-${handle.openingIndex}`;
    }
    default: {
      return entity.id;
    }
  }
}
